import axios, { AxiosResponse } from 'axios';
import { CONSTANTS } from "../common/constants";
import { ActionModel } from '../models/action.model';
import { AdviceRequestModel, AdviceRequestSetStatusModel } from '../models/advice-request.model';
import { AnonymousInfoModel } from '../models/anonymous-info.model';
import { BaseValidateModel, NewBaseValidateModel } from '../models/base-validate.model';
import { ClassRoomModel, ClassRoomSubjectModel } from '../models/class-room';
import { CommentModel, CommentRealtimeModel } from '../models/comment.model';
import { ConversationUser } from '../models/conversation.model';
import { ChangeTestCourseSchedule, CourseListModel, CourseModel, CourseRating, CourseResult, CourseScheduleDetailModel, CourseScheduleModel, CourseScheduleStudyProcess, CourseTestOfflineScoreModel, CourseYearModel, MyCourseModel, TestOverDeadline, CourseDetailScoreResponseModel, CourseSessionModel, ChangeCourseScheduleStatusValue } from '../models/course.model';
import { DashboardAdminCourse, DashboardAdminCourseDetail, DashboardAdminOverview, DashboardAdminScore, DashboardModel, DashboardTeacherStudentAllCourse, DashboardUserCourseModel, DashboardUserScore } from '../models/dashboard.model';
import { FAQModel } from '../models/faq.model';
import { FeedbackModel } from '../models/feedback.model';
import { AccountFilterModel, AdviceRequestFilterModel, BaseFilterModel, CommentFilterModel, CourseFilterModel, CourseRatingFilterModel, CourseScheduleFilterModel, CourseUserFilterModel, CourseAccountFilterModel, CourseYearFilterModel, DashboardOverviewFilter, DashboardUserFilterModel, FilterDashboardAdminCourseDetail, GroupManagerFilterModel, GuideFilterModel, MenuFilterModel, MessageByConversationFilterModel, NewCategoriesFilterModel, NewCategoryFilterModel, NotificationFilterModel, PaymentFilterModel, RecruitCandidateFilterModel, RecruitFilterModel, SlideFilterModel, StepFilterModel, SubjectFilterModel, TeacherFilterModel, TestCategoryFilterModel, TestFilterModel, TestQuestionGroupFilterModel, TestQuestionTypeFilterModel, TestRatingFilterModel, TestUserFilterModel, TestViewFilterModel, UserInfoFilterModel, CourseSessionFilterModel, TestQuestionTuLuanFilterModel, TestQuestionTuLuanDetailFilterModel } from '../models/filter.model';
import { FooterModel } from '../models/footer.model';
import { GroupManagerModel } from '../models/group-manager.model';
import { GuideModel } from '../models/guide.model';
import { HomeModel } from '../models/home.model';
import { LibraryGetFileModel } from '../models/library-get-file.model';
import { LibraryModel } from '../models/library.model';
import { Message } from '../models/message.model';
import { NewsCategoryModel } from '../models/news-category.model';
import { NotificationModel, NotificationTypeModel } from '../models/notification.model';
import { OTPModel } from '../models/otp.model';
import { PaymentChangeStatusModel, PaymentModel, PaymentTypeModel } from '../models/payment.model';
import { RecruitCandidateModel } from '../models/recruit-candidate.model';
import { RecruitModel } from '../models/recruit.model';
import { BaseResponseListModel, BaseResponseModel, ResponseListModel, ResponseModel, ResponseModelNew } from "../models/response.model";
import { RoleModel } from '../models/role.model';
import { RoleTypeDataModel } from '../models/roleTypeData.model';
import { SendEmailAnyContentModel, SendMailHHQModel, SendMailModel } from '../models/send-mail.model';
import { SlideModel } from "../models/slide.model";
import { StepModel } from '../models/step.model';
import { SubjectModel } from '../models/subject.model';
import { TeacherModelNew } from "../models/teacher.model";
import { TestAttackFileAcceptModel, TestAttackFileModel } from '../models/test-attack-file.model';
import { TestStatusValueModel, TestQuestionTuLuanModel, TestQuestionTuLuanDetailModel, GPTOutputQuestion, GPTInputQuestion, EssayGradingInput, EssayGradingOutput } from '../models/test-detail.model';
import { TestQuestionGroupModel } from '../models/test-question-group.model';
import { TestUserModel, TestUserOfflineModel } from '../models/test-user.model';
import { AccountChangePasswordModel, AccountLoginResponseModel, AccountUserModel, UpdateAccountInfoModel, UserInfoModel } from './../models/account.model';
import { ExamPageFilterModel } from './../models/filter.model';
import { InputTestModel } from './../models/input-test.model';
import { MenuModel, MenuTreeModel } from './../models/menu.model';
import { NewsModel, NewsOther } from './../models/news.model';
import { TestCategoryModel, TestDetailModel, TestDetailQuizModel, TestQuestionTypeModel, TestStatusFeeModel } from './../models/test-detail.model';
import { TestCourseScheduleModel, TestListModel, TestRatingModel, TestViewModel } from './../models/test.model';
import axiosSecretInstance from "./axios-secret.service";
import axiosInstance from "./axios.service";
const queryString = require('query-string');

class ApiService {
  // Class
  BASE_API = process.env.BASE_API || '';

  getBaseApi() {
    return process.env;
  }

  getClassPage(params: BaseFilterModel) {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get(`${CONSTANTS.BASE_API}/v1/class/GetClassPage?${queryParams}`)
  }

  // Students
  setUserRegister(data: { full_name: string, phone: string, email: string, password: string, password_confirm: string }) {
    return axiosSecretInstance.post(`${CONSTANTS.BASE_API}/v1/student/SetUserRegister`, data)
  }

  verifyCode(data: { key: string, phone: string, code: string, email: string }) {
    return axiosSecretInstance.put(`${CONSTANTS.BASE_API}/v1/student/VerifyCode`, data)
  }

  // Slides
  getSlides(query: SlideFilterModel): Promise<AxiosResponse<BaseResponseListModel<SlideModel[]>>> {
    const queryParams = queryString.stringify(query);
    return axiosSecretInstance.get<BaseResponseListModel<SlideModel[]>>(`${CONSTANTS.BASE_API}/api/Slide?${queryParams}`)
  }

  slideDel(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Slide/${id}`)
  }

  getSlideInfo(id: string): Promise<AxiosResponse<ResponseModelNew<SlideModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<SlideModel>>(`${CONSTANTS.BASE_API}/api/slide/${id}`)
  }

  setSlide(data: SlideModel): Promise<AxiosResponse<ResponseModelNew<SlideModel>>> {
    return axiosInstance.post<ResponseModelNew<SlideModel>>(`${CONSTANTS.BASE_API}/api/slide`, data)
  }

  getSlideByKey(key: string) {
    return axiosSecretInstance.get(`${CONSTANTS.BASE_API}/v1/slide/GetSlideByKey?key=${key}`)
  }

  //Teachers
  getTeachers(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<TeacherModelNew[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TeacherModelNew[]>>(`${CONSTANTS.BASE_API}/api/Teacher?${queryParams}`)
  }
  
  getTeachersFilter(params: TeacherFilterModel): Promise<AxiosResponse<BaseResponseListModel<TeacherModelNew[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TeacherModelNew[]>>(`${CONSTANTS.BASE_API}/api/Teacher/GetTeachersFilter?${queryParams}`)
  }

  setTeacher(data: TeacherModelNew): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
    return axiosInstance.post(`${CONSTANTS.BASE_API}/api/Teacher`, data)
  }

  teacherDel(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Teacher/${id}`)
  }

  getTeacherInfo(id: string): Promise<AxiosResponse<ResponseModelNew<TeacherModelNew>>> {
    return axiosSecretInstance.get<ResponseModelNew<TeacherModelNew>>(`${CONSTANTS.BASE_API}/api/Teacher/${id}`)
  }

  getTeacherInfoByAccountId(id: string): Promise<AxiosResponse<ResponseModelNew<TeacherModelNew>>> {
    return axiosInstance.get<ResponseModelNew<TeacherModelNew>>(`${CONSTANTS.BASE_API}/api/Teacher/GetTeacherByAccountId?id=${id}`)
  }
  // Comment

  getComments(params: CommentFilterModel): Promise<AxiosResponse<BaseResponseListModel<CommentModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CommentModel[]>>(`${CONSTANTS.BASE_API}/api/Comment?${queryParams}`)
  }

  setComment(data: CommentModel): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
    return axiosInstance.post(`${CONSTANTS.BASE_API}/api/Comment`, data)
  }

  commentDelete(id: string): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Comment/${id}`)
  }

  getCommentDetail(id: string): Promise<AxiosResponse<ResponseModelNew<CommentModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CommentModel>>(`${CONSTANTS.BASE_API}/api/Comment/${id}`)
  }

    // Commentrealtime

    getCommentRealtimes(params: CommentFilterModel): Promise<AxiosResponse<BaseResponseListModel<CommentRealtimeModel[]>>> {
      const queryParams = queryString.stringify(params);
      return axiosSecretInstance.get<BaseResponseListModel<CommentRealtimeModel[]>>(`${CONSTANTS.BASE_API}/api/CommentRealtime?${queryParams}`)
    }
  
    setCommentRealtimes(data: CommentRealtimeModel): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
      return axiosInstance.post(`${CONSTANTS.BASE_API}/api/CommentRealtime`, data)
    }
  
    commentRealtimesDelete(id: string): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
      return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/CommentRealtime/${id}`)
    }
  
    getCommentRealtimesDetail(id: string): Promise<AxiosResponse<ResponseModelNew<CommentRealtimeModel>>> {
      return axiosSecretInstance.get<ResponseModelNew<CommentRealtimeModel>>(`${CONSTANTS.BASE_API}/api/CommentRealtime/${id}`)
    }
  


  // Menus
  getMenuHome() {
    return axiosSecretInstance.get(`${CONSTANTS.BASE_API}/v1/slide/GetMenuHome`)
  }

  // course-new
    
  getCourses(params: CourseFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseListModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseListModel[]>>(`${CONSTANTS.BASE_API}/api/Course?${queryParams}`)
  }

  getCoursesUser(params: CourseUserFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseListModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseListModel[]>>(`${CONSTANTS.BASE_API}/api/Course/GetCoursesUser?${queryParams}`)
  }

  getAccountsInCourse(params: CourseAccountFilterModel): Promise<AxiosResponse<BaseResponseListModel<AccountUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AccountUserModel[]>>(`${CONSTANTS.BASE_API}/api/Course/GetAccountsInCourse?${queryParams}`)
  }

  deleteCourse(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Course/${id}`)
  }

  getCourseById(id: string, accountId: string | null = null, fromAdmin: number = 0): Promise<AxiosResponse<ResponseModelNew<CourseListModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseListModel>>(`${CONSTANTS.BASE_API}/api/Course/${id}?accountId=${accountId}&fromAdmin=${fromAdmin}`)
  }

  getCourseInfoById(id: string): Promise<AxiosResponse<ResponseModelNew<CourseListModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseListModel>>(`${CONSTANTS.BASE_API}/api/Course/GetCourseInfoById?id=${id}`)
  }

  getCourseByIdCMS(id: string, accountId: string | null = null): Promise<AxiosResponse<ResponseModelNew<CourseListModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseListModel>>(`${CONSTANTS.BASE_API}/api/Course/GetCourseByIdCMS?id=${id}&accountId=${accountId}`)
  }
  
  getMyCourse(): Promise<AxiosResponse<ResponseModelNew<MyCourseModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<MyCourseModel>>(`${CONSTANTS.BASE_API}/api/Course/GetMyCourse`)
  }

  setCourse(data: CourseListModel): Promise<AxiosResponse<ResponseModelNew<CourseListModel>>> {
    return axiosInstance.post<ResponseModelNew<CourseListModel>>(`${CONSTANTS.BASE_API}/api/Course`, data)
  }

  getTestResults(courseId: string): Promise<AxiosResponse<ResponseModelNew<CourseResult>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseResult>>(`${CONSTANTS.BASE_API}/api/Course/GetTestResults?id=${courseId}`)
  }

  getCourseDetailScores(courseId: string, courseSession: string = ""): Promise<AxiosResponse<ResponseModelNew<CourseDetailScoreResponseModel>>> {
    return axiosInstance.get<ResponseModelNew<CourseDetailScoreResponseModel>>(`${CONSTANTS.BASE_API}/api/Course/GetCourseDetailScores?courseId=${courseId}&courseSession=${courseSession}`)
  }

  getCourseOverDeadline(courseId: string): Promise<AxiosResponse<BaseResponseListModel<TestOverDeadline[]>>> {
    return axiosInstance.get<BaseResponseListModel<TestOverDeadline[]>>(`${CONSTANTS.BASE_API}/api/Course/GetCourseOverDeadline?courseId=${courseId}`)
  }

  getCourseTestOfflineScore(courseId: string, testId: string): Promise<AxiosResponse<BaseResponseListModel<CourseTestOfflineScoreModel[]>>> {
    return axiosInstance.get<BaseResponseListModel<CourseTestOfflineScoreModel[]>>(`${CONSTANTS.BASE_API}/api/Course/GetCourseTestOfflineScore?courseId=${courseId}&testId=${testId}`)
  }

  // Course year
  getCourseYears(params: CourseYearFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseYearModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseYearModel[]>>(`${CONSTANTS.BASE_API}/api/CourseYear?${queryParams}`)
  }

  deleteCourseYear(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/CourseYear/${id}`)
  }

  getCourseYearById(id: string): Promise<AxiosResponse<ResponseModelNew<CourseYearModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseYearModel>>(`${CONSTANTS.BASE_API}/api/CourseYear/${id}`)
  }

  setCourseYear(data: CourseYearModel): Promise<AxiosResponse<ResponseModelNew<CourseYearModel | string>>> {
    return axiosInstance.post<ResponseModelNew<CourseYearModel | string>>(`${CONSTANTS.BASE_API}/api/CourseYear`, data)
  }

  // Course Session
  getCourseSessions(params: CourseSessionFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseSessionModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseSessionModel[]>>(`${CONSTANTS.BASE_API}/api/CourseSession?${queryParams}`)
  }

  deleteCourseSession(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/CourseSession/${id}`)
  }

  getCourseSessionById(id: string): Promise<AxiosResponse<ResponseModelNew<CourseSessionModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseSessionModel>>(`${CONSTANTS.BASE_API}/api/CourseSession/${id}`)
  }

  setCourseSession(data: CourseSessionModel): Promise<AxiosResponse<ResponseModelNew<CourseSessionModel | string>>> {
    return axiosInstance.post<ResponseModelNew<CourseSessionModel | string>>(`${CONSTANTS.BASE_API}/api/CourseSession`, data)
  }

  // Course Rating
  getCourseRatings(params: CourseRatingFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseRating[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseRating[]>>(`${CONSTANTS.BASE_API}/api/CourseRating?${queryParams}`)
  }

  deleteCourseRating(id: string) {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/CourseRating/${id}`)
  }

  getCourseRatingById(id: string): Promise<AxiosResponse<ResponseModelNew<CourseRating>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseRating>>(`${CONSTANTS.BASE_API}/api/CourseRating/${id}`)
  }

  setCourseRating(data: CourseRating): Promise<AxiosResponse<ResponseModelNew<CourseRating | string>>> {
    return axiosInstance.post<ResponseModelNew<CourseRating | string>>(`${CONSTANTS.BASE_API}/api/CourseRating`, data)
  }

  // course schedule
  getCourseSchedules(params: CourseScheduleFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseScheduleDetailModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<CourseScheduleDetailModel[]>>(`${CONSTANTS.BASE_API}/api/CourseSchedule?${queryParams}`)
  }

  getCourseScheduleStudyProgress(courseId: string, accountId: string | null = null): Promise<AxiosResponse<BaseResponseListModel<CourseScheduleStudyProcess[]>>> {
    return axiosSecretInstance.get<BaseResponseListModel<CourseScheduleStudyProcess[]>>(`${CONSTANTS.BASE_API}/api/CourseSchedule/GetStudyProcess?courseId=${courseId}&accountId=${accountId}`)
  }

  getStudyProcessAbility(courseId: string, accountId: string | null = null): Promise<AxiosResponse<BaseResponseListModel<TestUserModel[]>>> {
    return axiosSecretInstance.get<BaseResponseListModel<TestUserModel[]>>(`${CONSTANTS.BASE_API}/api/CourseSchedule/GetStudyProcessAbility?courseId=${courseId}&accountId=${accountId}`)
  }

  deleteCourseSchedule(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/CourseSchedule/${id}`)
  }

  getCourseScheduleById(id: string): Promise<AxiosResponse<ResponseModelNew<CourseScheduleDetailModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<CourseScheduleDetailModel>>(`${CONSTANTS.BASE_API}/api/CourseSchedule/${id}`)
  }

  setCourseSchedule(data: CourseScheduleModel): Promise<AxiosResponse<ResponseModelNew<CourseScheduleModel | string>>> {
    return axiosInstance.post<ResponseModelNew<CourseScheduleModel | string>>(`${CONSTANTS.BASE_API}/api/CourseSchedule`, data)
  }

  changeTestCourseSchedule(data: ChangeTestCourseSchedule): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post(`${CONSTANTS.BASE_API}/api/CourseSchedule/ChangeTestCourseSchedule`, data)
  }

  changeCourseScheduleStatusValue(data: ChangeCourseScheduleStatusValue): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post(`${CONSTANTS.BASE_API}/api/CourseSchedule/ChangeCourseScheduleStatusValue`, data)
  }

  // Test
  getExamPage(params: ExamPageFilterModel): Promise<AxiosResponse<ResponseListModel<TestListModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<ResponseListModel<TestListModel[]>>(`${CONSTANTS.BASE_API}/v1/exam/GetExamPage?${queryParams}`)
  }

  getExamTest(id: string): Promise<AxiosResponse<ResponseListModel<TestDetailModel>>> {
    return axiosSecretInstance.get<ResponseListModel<TestDetailModel>>(`${CONSTANTS.BASE_API}/v1/exam/GetExamTest?exam_id=${id}`)
  }

  getTestRatingById(courseId: string, testId: string): Promise<AxiosResponse<ResponseListModel<TestRatingModel>>> {
    return axiosInstance.get<ResponseListModel<TestRatingModel>>(`${CONSTANTS.BASE_API}/api/TestRating/GetTestRatingById?courseId=${courseId}&testId=${testId}`)
  }

  getTestRatings(params: TestRatingFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestRatingModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestRatingModel[]>>(`${CONSTANTS.BASE_API}/api/TestRating?${queryParams}`)
  }

  setTestRating(data: TestRatingModel): Promise<AxiosResponse<ResponseModelNew<TestRatingModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestRatingModel>>(`${CONSTANTS.BASE_API}/api/TestRating`, data)
  }

  setInputTest(data: InputTestModel) {
    return axiosSecretInstance.post(`${CONSTANTS.BASE_API}/v1/exam/SetInputTest`, data)
  }

  submitTest(data: {email: string, t_id: string}) {
    return axiosSecretInstance.post(`${CONSTANTS.BASE_API}/v1/exam/SubmitTest`, data)
  }

  // Library
  getLibrariesFolder(data: LibraryGetFileModel): Promise<AxiosResponse<BaseResponseListModel<LibraryModel[]>>> {
    return axiosSecretInstance.post<BaseResponseListModel<LibraryModel[]>>(`${CONSTANTS.BASE_API}/api/Library/GetLibrariesFolder`, data)
  }
  
  getLibraries(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<LibraryModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<LibraryModel[]>>(`${CONSTANTS.BASE_API}/api/Library/GetLibraries?${queryParams}`)
  }

  getLibrariesFile(data: LibraryGetFileModel): Promise<AxiosResponse<BaseResponseListModel<LibraryModel[]>>> {
    return axiosSecretInstance.post<BaseResponseListModel<LibraryModel[]>>(`${CONSTANTS.BASE_API}/api/Library/GetLibrariesFile`, data)
  }

  getLibraryInfo(id: string): Promise<AxiosResponse<ResponseModel<LibraryModel>>> {
    return axiosSecretInstance.get<ResponseModel<LibraryModel>>(`${CONSTANTS.BASE_API}/api/Library/${id}`)
  }

  deleteLibrary(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Library?id=${id}`)
  }

  deleteLibraryFile(id: string, filePath: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Library/DeleteLibraryFile?id=${id}&imagePath=${filePath}`)
  }

  setLibrary(data: LibraryModel): Promise<AxiosResponse<ResponseModelNew<any>>> {
    return axiosInstance.post<ResponseModelNew<any>>(`${CONSTANTS.BASE_API}/api/Library/SetLibrary`, data)
  }

  deleteFile(filePath: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/File?filePath=${filePath}`)
  }

  deleteFiles(fileUrls: string[]): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/File/DeleteFiles`, { data: fileUrls });
  }

  setFile(file: File, folder: string = ''): Promise<AxiosResponse<ResponseModelNew<any>>> {
      var bodyFormData = new FormData();
      bodyFormData.append('file', file);
      bodyFormData.append('folder', folder);
      const token = localStorage.getItem(CONSTANTS.LOGIN_TOKEN);
      return axios.post<ResponseModelNew<any>>(`${CONSTANTS.BASE_API}/api/File`, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })
  }

  setFiles(files: (File | null)[], folder: string = ''): Promise<AxiosResponse<ResponseModelNew<any>>> {
    var bodyFormData = new FormData();
    files.forEach((file) => {
      if (file) {
        bodyFormData.append('files', file);
      }
    });
    bodyFormData.append('folder', folder);
    const token = localStorage.getItem(CONSTANTS.LOGIN_TOKEN);
    return axios.post<ResponseModelNew<any>>(`${CONSTANTS.BASE_API}/api/File/UploadFiles`, bodyFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    })
  }

  // New category
  getNewsCategories(params: NewCategoriesFilterModel): Promise<AxiosResponse<BaseResponseListModel<NewsCategoryModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<NewsCategoryModel[]>>(`${CONSTANTS.BASE_API}/api/NewsCategory?${queryParams}`)
  }

  deleteNewsCategory(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/NewsCategory/${id}`)
  }

  getNewsCategoryById(id: string): Promise<AxiosResponse<ResponseModelNew<NewsCategoryModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<NewsCategoryModel>>(`${CONSTANTS.BASE_API}/api/NewsCategory/${id}`)
  }

  setNewsCategory(data: NewsCategoryModel): Promise<AxiosResponse<ResponseModelNew<NewsCategoryModel>>> {
    return axiosInstance.post<ResponseModelNew<NewsCategoryModel>>(`${CONSTANTS.BASE_API}/api/NewsCategory`, data)
  }

  // News
  getNews(params: NewCategoryFilterModel): Promise<AxiosResponse<BaseResponseListModel<NewsModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<NewsModel[]>>(`${CONSTANTS.BASE_API}/api/News?${queryParams}`)
  }

  deleteNews(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/News/${id}`)
  }

  getNewsById(id: string): Promise<AxiosResponse<ResponseModelNew<NewsModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<NewsModel>>(`${CONSTANTS.BASE_API}/api/News/${id}`)
  }

  getNewsOther(): Promise<AxiosResponse<ResponseModelNew<NewsOther>>> {
    return axiosSecretInstance.get<ResponseModelNew<NewsOther>>(`${CONSTANTS.BASE_API}/api/News/GetNewsOther`)
  }

  setNews(data: NewsModel): Promise<AxiosResponse<ResponseModelNew<NewsModel>>> {
    return axiosInstance.post<ResponseModelNew<NewsModel>>(`${CONSTANTS.BASE_API}/api/News`, data)
  }
  
  updateNewsView(id: string): Promise<AxiosResponse<ResponseModelNew<NewsModel>>> {
    return axiosSecretInstance.get(`${CONSTANTS.BASE_API}/api/News/UpdateNewsView?id=${id}`)
  }

  // Menus
  getMenus(params: MenuFilterModel): Promise<AxiosResponse<BaseResponseListModel<MenuModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<MenuModel[]>>(`${CONSTANTS.BASE_API}/api/Menu?${queryParams}`)
  }

  getMenuRoleAcounts(accountId: string): Promise<AxiosResponse<BaseResponseListModel<MenuModel[]>>> {
    return axiosSecretInstance.get<BaseResponseListModel<MenuModel[]>>(`${CONSTANTS.BASE_API}/api/Menu/GetMenuRoleAcounts?accountId=${accountId}`)
  }

  getMenusTree(params: MenuFilterModel): Promise<AxiosResponse<BaseResponseListModel<MenuTreeModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<MenuTreeModel[]>>(`${CONSTANTS.BASE_API}/api/Menu/GetMenusTree?${queryParams}`)
  }

  getMenusById(id: string): Promise<AxiosResponse<ResponseModelNew<MenuModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<MenuModel>>(`${CONSTANTS.BASE_API}/api/Menu/${id}`)
  }

  deleteMenu(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Menu/${id}`)
  }
  
  setMenu(data: MenuModel): Promise<AxiosResponse<ResponseModelNew<MenuModel>>> {
    return axiosInstance.post<ResponseModelNew<MenuModel>>(`${CONSTANTS.BASE_API}/api/Menu`, data)
  }

  // Class room
  getClassRooms(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<ClassRoomModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<ClassRoomModel[]>>(`${CONSTANTS.BASE_API}/api/ClassRoom?${queryParams}`)
  }

  getClassRoomById(id: string): Promise<AxiosResponse<ResponseModelNew<ClassRoomModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<ClassRoomModel>>(`${CONSTANTS.BASE_API}/api/ClassRoom/${id}`)
  }

  deleteClassRoom(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/ClassRoom/${id}`)
  }
  
  setClassRoom(data: ClassRoomModel): Promise<AxiosResponse<ResponseModelNew<ClassRoomModel>>> {
    return axiosInstance.post<ResponseModelNew<ClassRoomModel>>(`${CONSTANTS.BASE_API}/api/ClassRoom`, data)
  }

  setClassRoomSubject(data: ClassRoomSubjectModel): Promise<AxiosResponse<ResponseModelNew<ClassRoomSubjectModel>>> {
    return axiosInstance.post<ResponseModelNew<ClassRoomSubjectModel>>(`${CONSTANTS.BASE_API}/api/ClassRoom/SetClassRoomSubject`, data)
  }

  // FAQ
  getFaqs(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<FAQModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<FAQModel[]>>(`${CONSTANTS.BASE_API}/api/faq?${queryParams}`)
  }

  getFaqById(id: string): Promise<AxiosResponse<ResponseModelNew<FAQModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<FAQModel>>(`${CONSTANTS.BASE_API}/api/faq/${id}`)
  }

  deleteFaq(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/faq/${id}`)
  }
  
  setFaq(data: FAQModel): Promise<AxiosResponse<ResponseModelNew<FAQModel>>> {
    return axiosInstance.post<ResponseModelNew<FAQModel>>(`${CONSTANTS.BASE_API}/api/faq`, data)
  }

  // Footer
  getFeedbacks(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<FeedbackModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<FeedbackModel[]>>(`${CONSTANTS.BASE_API}/api/feedback?${queryParams}`)
  }

  getFeedbackById(id: string): Promise<AxiosResponse<ResponseModelNew<FeedbackModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<FeedbackModel>>(`${CONSTANTS.BASE_API}/api/feedback/${id}`)
  }

  deleteFeedback(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/feedback/${id}`)
  }
  
  setFeedback(data: FeedbackModel): Promise<AxiosResponse<ResponseModelNew<FeedbackModel>>> {
    return axiosInstance.post<ResponseModelNew<FeedbackModel>>(`${CONSTANTS.BASE_API}/api/feedback`, data)
  }

  //Feedback

  getFooters(params: BaseFilterModel, signal?: AbortSignal | undefined): Promise<AxiosResponse<BaseResponseListModel<FooterModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<FooterModel[]>>(`${CONSTANTS.BASE_API}/api/footer?${queryParams}`, { signal})
  }

  getFooterById(id: string): Promise<AxiosResponse<ResponseModelNew<FooterModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<FooterModel>>(`${CONSTANTS.BASE_API}/api/footer/${id}`)
  }

  deleteFooter(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/footer/${id}`)
  }
  
  setFooter(data: FooterModel): Promise<AxiosResponse<ResponseModelNew<FooterModel>>> {
    return axiosInstance.post<ResponseModelNew<FooterModel>>(`${CONSTANTS.BASE_API}/api/footer`, data)
  }


   // Recruit
   getRecruits(params: RecruitFilterModel): Promise<AxiosResponse<BaseResponseListModel<RecruitModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<RecruitModel[]>>(`${CONSTANTS.BASE_API}/api/recruit?${queryParams}`)
  }

  getRecruitById(id: string): Promise<AxiosResponse<ResponseModelNew<RecruitModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<RecruitModel>>(`${CONSTANTS.BASE_API}/api/recruit/${id}`)
  }

  deleteRecruit(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/recruit/${id}`)
  }
  
  setRecruit(data: RecruitModel): Promise<AxiosResponse<ResponseModelNew<RecruitModel>>> {
    return axiosInstance.post<ResponseModelNew<RecruitModel>>(`${CONSTANTS.BASE_API}/api/recruit`, data)
  }
   // RecruitCandidate
  getRecruitCandidates(params: RecruitCandidateFilterModel): Promise<AxiosResponse<BaseResponseListModel<RecruitCandidateModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<RecruitCandidateModel[]>>(`${CONSTANTS.BASE_API}/api/RecruitCandidate?${queryParams}`)
  }

  getRecruitCandidateById(id: string): Promise<AxiosResponse<ResponseModelNew<RecruitCandidateModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<RecruitCandidateModel>>(`${CONSTANTS.BASE_API}/api/RecruitCandidate/${id}`)
  }

  deleteRecruitCandidate(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/RecruitCandidate/${id}`)
  }
  
  setRecruitCandidate(data: RecruitCandidateModel): Promise<AxiosResponse<ResponseModelNew<RecruitCandidateModel>>> {
    return axiosInstance.post<ResponseModelNew<RecruitCandidateModel>>(`${CONSTANTS.BASE_API}/api/RecruitCandidate`, data)
  }

  // Tài khoản
  getAccounts(params: AccountFilterModel): Promise<AxiosResponse<BaseResponseListModel<AccountUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AccountUserModel[]>>(`${CONSTANTS.BASE_API}/api/Account?${queryParams}`)
  }

  getAccountsNotTeacher(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<AccountUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AccountUserModel[]>>(`${CONSTANTS.BASE_API}/api/Account/GetAccountsNotTeacher?${queryParams}`)
  }

  getAccountManageMembers(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<AccountUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AccountUserModel[]>>(`${CONSTANTS.BASE_API}/api/Account/GetAccountManageMembers?${queryParams}`)
  }

  getAccountDetail(id: string): Promise<AxiosResponse<ResponseModelNew<AccountUserModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<AccountUserModel>>(`${CONSTANTS.BASE_API}/api/Account/${id}`)
  }

  getAccountByUserName(id: string): Promise<AxiosResponse<ResponseModelNew<AccountUserModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<AccountUserModel>>(`${CONSTANTS.BASE_API}/api/Account/GetAccountByUserName?username=${id}`)
  }

  deleteAccount(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Account/${id}`)
  }
  
  setAccount(data: AccountUserModel): Promise<AxiosResponse<ResponseModelNew<AccountUserModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountUserModel>>(`${CONSTANTS.BASE_API}/api/account/SetAccount`, data)
  }

  setAccountUser(data: AccountUserModel): Promise<AxiosResponse<ResponseModelNew<AccountUserModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountUserModel>>(`${CONSTANTS.BASE_API}/api/account/SetAccountUser`, data)
  }

  setAccountRegister(data: AccountUserModel): Promise<AxiosResponse<ResponseModelNew<AccountUserModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountUserModel>>(`${CONSTANTS.BASE_API}/api/account/SetAccountRegister`, data)
  }

  setAccountChangePassword(data: AccountChangePasswordModel): Promise<AxiosResponse<ResponseModelNew<AccountChangePasswordModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountChangePasswordModel>>(`${CONSTANTS.BASE_API}/api/account/SetAccountChangePassword`, data)
  }

  setChangePassword(data: AccountChangePasswordModel): Promise<AxiosResponse<ResponseModelNew<AccountChangePasswordModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountChangePasswordModel>>(`${CONSTANTS.BASE_API}/api/account/SetAccountPassword`, data)
  }

  updateAccountInfo(data: UpdateAccountInfoModel): Promise<AxiosResponse<ResponseModelNew<UpdateAccountInfoModel>>> {
    return axiosInstance.put<ResponseModelNew<UpdateAccountInfoModel>>(`${CONSTANTS.BASE_API}/api/Account/UpdateAccountInfo`, data)
  }
  
  // UserInfo
  setUserInfo(data: UserInfoModel): Promise<AxiosResponse<ResponseModelNew<string>>> {
    return axiosInstance.post<ResponseModelNew<string>>(`${CONSTANTS.BASE_API}/api/UserControler`, data)
  }

  getUserInfos(params: UserInfoFilterModel): Promise<AxiosResponse<BaseResponseListModel<UserInfoModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<UserInfoModel[]>>(`${CONSTANTS.BASE_API}/api/UserControler?${queryParams}`)
  }

  getUserInfoDetail(id: string): Promise<AxiosResponse<ResponseModelNew<UserInfoModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<UserInfoModel>>(`${CONSTANTS.BASE_API}/api/UserControler/${id}`)
  }

  deleteUserInfo(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/UserControler/${id}`)
  }

  // Test User
  getTestUsers(params: TestUserFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TestUserModel[]>>(`${CONSTANTS.BASE_API}/api/TestUser?${queryParams}`)
  }

  getMyTestAbility(): Promise<AxiosResponse<BaseResponseListModel<TestUserModel[]>>> {
    return axiosSecretInstance.get<BaseResponseListModel<TestUserModel[]>>(`${CONSTANTS.BASE_API}/api/TestUser/GetMyTestAbility`)
  }

  getTestUserById(id: string): Promise<AxiosResponse<ResponseModelNew<TestUserModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestUserModel>>(`${CONSTANTS.BASE_API}/api/TestUser/${id}`)
  }

  getTestUserByTestUserId(testId: string, userId: string): Promise<AxiosResponse<ResponseModelNew<TestUserModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestUserModel>>(`${CONSTANTS.BASE_API}/api/TestUser/GetTestUserByTestUserId?testId=${testId}&userId=${userId}`)
  }

  deleteTestUser(id: string, courseId: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/TestUser?id=${id}&courseId=${courseId}`)
  }
  
  setTestUser(data: TestUserModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestUser`, data)
  }

  setTestUserOffline(data: TestUserOfflineModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestUser/SetTestUserOffline`, data)
  }

  setTestUserActive(testUserId: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestUser/SetTestUserActive?testUserId=${testUserId}`, null);
  }

  // Role
  getRoles(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<RoleModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<RoleModel[]>>(`${CONSTANTS.BASE_API}/api/Role?${queryParams}`)
  }

  getRoleDetail(id: string): Promise<AxiosResponse<ResponseModelNew<RoleModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<RoleModel>>(`${CONSTANTS.BASE_API}/api/Role/${id}`)
  }

  deleteRole(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Role/${id}`)
  }
  
  setRole(data: RoleModel): Promise<AxiosResponse<ResponseModelNew<RoleModel>>> {
    return axiosInstance.post<ResponseModelNew<RoleModel>>(`${CONSTANTS.BASE_API}/api/Role`, data)
  }

  // Action
  getActions(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<ActionModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<ActionModel[]>>(`${CONSTANTS.BASE_API}/api/Role/GetActions?${queryParams}`)
  }

  getActionDetail(id: string): Promise<AxiosResponse<ResponseModelNew<ActionModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<ActionModel>>(`${CONSTANTS.BASE_API}/api/Role/GetActionById?id=${id}`)
  }

  getRoleByAccountId(): Promise<AxiosResponse<ResponseModelNew<ActionModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<ActionModel>>(`${CONSTANTS.BASE_API}/api/Role/GetRoleByAccountId`)
  }

  deleteAction(id: string): Promise<AxiosResponse<ResponseModelNew<ActionModel>>> {
    return axiosInstance.delete<ResponseModelNew<ActionModel>>(`${CONSTANTS.BASE_API}/api/Role/DeleteAction?id=${id}`)
  }
  
  setAction(data: ActionModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Role/SetAction`, data)
  }

  // Authen
  login(Username: string, Password: string): Promise<AxiosResponse<ResponseModelNew<AccountLoginResponseModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountLoginResponseModel>>(`${CONSTANTS.BASE_API}/api/Authentication/authenticate`, {
      Username, Password
    })
  }

  forgotPassgot(email: string): Promise<AxiosResponse<ResponseModelNew<AccountLoginResponseModel>>> {
    return axiosInstance.post<ResponseModelNew<AccountLoginResponseModel>>(`${CONSTANTS.BASE_API}/api/Account/ForgotPassword?email=${email}`, null)
  }
  forgotPassgotRequest(email: string, userName: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Account/ForgotPasswordRequest?email=${email}&userName=${userName}`, null)
  }
  forgotPassgotVerify(id: string, code: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Account/ForgotPasswordVerify?id=${id}&code=${code}`, null)
  }

  changePasswordByEmail(email: string, password: string, userName: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Account/changePasswordByEmail`, {
      email,
      password,
      userName
    })
  }
  
  activeAccount(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Account/ActiveAccount?accountId=${id}`);
  }
  // Subject
  getSubjects(params: SubjectFilterModel): Promise<AxiosResponse<BaseResponseListModel<SubjectModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<SubjectModel[]>>(`${CONSTANTS.BASE_API}/api/Subject?${queryParams}`)
  }

  getSubjectDetail(id: string): Promise<AxiosResponse<ResponseModelNew<SubjectModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<SubjectModel>>(`${CONSTANTS.BASE_API}/api/Subject/${id}`)
  }

  deleteSubject(id: string): Promise<AxiosResponse<ResponseModelNew<SubjectModel>>> {
    return axiosInstance.delete<ResponseModelNew<SubjectModel>>(`${CONSTANTS.BASE_API}/api/Subject/${id}`)
  }

  deleteSubjectFromClass(classRoomId: string, subjectId: string): Promise<AxiosResponse<ResponseModelNew<SubjectModel>>> {
    return axiosInstance.delete<ResponseModelNew<SubjectModel>>(`${CONSTANTS.BASE_API}/api/Subject/DeleteSubject/${classRoomId}/${subjectId}`)
  }
  
  setSubject(data: SubjectModel): Promise<AxiosResponse<ResponseModelNew<SubjectModel>>> {
    return axiosInstance.post<ResponseModelNew<SubjectModel>>(`${CONSTANTS.BASE_API}/api/Subject`, data)
  }

  // Anonymous Info
  getAnonymousInfos(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<AnonymousInfoModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AnonymousInfoModel[]>>(`${CONSTANTS.BASE_API}/api/AnonymousInfo?${queryParams}`)
  }

  getAnonymousDetail(id: string): Promise<AxiosResponse<ResponseModelNew<AnonymousInfoModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<AnonymousInfoModel>>(`${CONSTANTS.BASE_API}/api/AnonymousInfo/${id}`)
  }

  deleteAnonymousInfo(id: string): Promise<AxiosResponse<ResponseModelNew<AnonymousInfoModel>>> {
    return axiosInstance.delete<ResponseModelNew<AnonymousInfoModel>>(`${CONSTANTS.BASE_API}/api/AnonymousInfo/${id}`)
  }
  
  setAnonymousInfo(data: AnonymousInfoModel): Promise<AxiosResponse<ResponseModelNew<AnonymousInfoModel>>> {
    return axiosInstance.post<ResponseModelNew<AnonymousInfoModel>>(`${CONSTANTS.BASE_API}/api/AnonymousInfo`, data)
  }

  // Test
  getTests(params: TestFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestDetailModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TestDetailModel[]>>(`${CONSTANTS.BASE_API}/api/test?${queryParams}`)
  }

  getTestDetail(id: string): Promise<AxiosResponse<ResponseModelNew<TestDetailModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestDetailModel>>(`${CONSTANTS.BASE_API}/api/test/${id}`)
  }

  getTestNewDetail(id: string, isGetAnwser: boolean = false): Promise<AxiosResponse<ResponseModelNew<TestDetailModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestDetailModel>>(`${CONSTANTS.BASE_API}/api/Test/GetTestNewById?id=${id}&isGetAnwser=${isGetAnwser}`)
  }

  getLivestreamDetail(id: string): Promise<AxiosResponse<ResponseModelNew<TestDetailModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestDetailModel>>(`${CONSTANTS.BASE_API}/api/Test/GetTestLivestreamById?livestreamId=${id}`)
  }

  updateTestOrder(id: string, order: number): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Test/UpdateTestOrder?id=${id}&order=${order}`, null)
  }

  deleteTest(id: string): Promise<AxiosResponse<ResponseModelNew<TestDetailModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<TestDetailModel>>(`${CONSTANTS.BASE_API}/api/test/${id}`)
  }
  
  setTest(data: TestDetailModel): Promise<AxiosResponse<ResponseModelNew<string>>> {
    return axiosSecretInstance.post<ResponseModelNew<string>>(`${CONSTANTS.BASE_API}/api/test`, data);
  }

  setTestNew(data: TestDetailModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Test/SetTestNew`, data);
  }

  setTestChangeStatus(data: TestStatusFeeModel): Promise<AxiosResponse<ResponseModelNew<TestStatusFeeModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestStatusFeeModel>>(`${CONSTANTS.BASE_API}/api/test/SetTestChangeStatus`, data);
  }

  setTestChangeStatusValue(data: TestStatusValueModel): Promise<AxiosResponse<ResponseModelNew<TestStatusValueModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestStatusValueModel>>(`${CONSTANTS.BASE_API}/api/test/SetTestChangeStatusValue`, data);
  }

  setTestChangeFree(data: TestStatusFeeModel): Promise<AxiosResponse<ResponseModelNew<TestStatusFeeModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestStatusFeeModel>>(`${CONSTANTS.BASE_API}/api/test/SetTestChangeFree`, data);
  }

  checkTestInCourseSchedule(courseId: string, testId: string): Promise<AxiosResponse<ResponseModelNew<boolean>>> {
    return axiosInstance.get<ResponseModelNew<boolean>>(`${CONSTANTS.BASE_API}/api/Test/CheckTestInCourseSchedule?courseId=${courseId}&testId=${testId}`)
  }

  // Test Category
  getTestCategories(params: TestCategoryFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestCategoryModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TestCategoryModel[]>>(`${CONSTANTS.BASE_API}/api/TestCategory?${queryParams}`);
  }

  getTestCategoryDetail(id: string): Promise<AxiosResponse<ResponseModelNew<TestCategoryModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestCategoryModel>>(`${CONSTANTS.BASE_API}/api/TestCategory/${id}`);
  }

  deleteTestCategory(id: string): Promise<AxiosResponse<ResponseModelNew<TestCategoryModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<TestCategoryModel>>(`${CONSTANTS.BASE_API}/api/TestCategory/${id}`)
  }
  
  setTestCategory(data: TestCategoryModel): Promise<AxiosResponse<ResponseModelNew<TestCategoryModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestCategoryModel>>(`${CONSTANTS.BASE_API}/api/TestCategory`, data)
  }

  // Test Question Type
  getTestQuestionTypes(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestQuestionTypeModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<TestQuestionTypeModel[]>>(`${CONSTANTS.BASE_API}/api/TestQuestionType?${queryParams}`);
  }

  getTestQuestionType(id: string): Promise<AxiosResponse<ResponseModelNew<TestQuestionTypeModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<TestQuestionTypeModel>>(`${CONSTANTS.BASE_API}/api/TestQuestionType/${id}`);
  }

  deleteQuestionType(id: string): Promise<AxiosResponse<ResponseModelNew<TestQuestionTypeModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<TestQuestionTypeModel>>(`${CONSTANTS.BASE_API}/api/TestQuestionType/${id}`)
  }
  
  setQuestionType(data: TestQuestionTypeModel): Promise<AxiosResponse<ResponseModelNew<TestQuestionTypeModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestQuestionTypeModel>>(`${CONSTANTS.BASE_API}/api/TestQuestionType`, data)
  }

  // Test course schedule
  setTestCourseSchedule(data: TestCourseScheduleModel): Promise<AxiosResponse<ResponseModelNew<TestCourseScheduleModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestCourseScheduleModel>>(`${CONSTANTS.BASE_API}/api/TestCourseSchedule`, data)
  }

  deleteTestCourseScheduleId(testId: string, testCourseScheduleId: string): Promise<AxiosResponse<ResponseModelNew<TestQuestionTypeModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<TestQuestionTypeModel>>(`${CONSTANTS.BASE_API}/api/TestCourseSchedule?testId=${testId}&testCourseScheduleId=${testCourseScheduleId}`)
  }

  changeCourseScheduleStatus(courseId: string, testId: string, isNotification: number) : Promise<AxiosResponse<ResponseModelNew<TestCourseScheduleModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<TestCourseScheduleModel>>(`${CONSTANTS.BASE_API}/api/TestCourseSchedule/ChangeStatus?courseId=${courseId}&testId=${testId}&isNotification=${isNotification}`, null)
  }

  // Home
  getHomes(): Promise<AxiosResponse<ResponseModelNew<HomeModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<HomeModel>>(`${CONSTANTS.BASE_API}/api/Home`);
  }

  // Advice Request
  getAdviceRequests(params: AdviceRequestFilterModel): Promise<AxiosResponse<BaseResponseListModel<AdviceRequestModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<AdviceRequestModel[]>>(`${CONSTANTS.BASE_API}/api/AdviceRequest?${queryParams}`);
  }

  getAdviceRequestById(id: string): Promise<AxiosResponse<ResponseModelNew<AdviceRequestModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<AdviceRequestModel>>(`${CONSTANTS.BASE_API}/api/AdviceRequest/${id}`);
  }

  deleteAdviceRequest(id: string): Promise<AxiosResponse<ResponseModelNew<AdviceRequestModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<AdviceRequestModel>>(`${CONSTANTS.BASE_API}/api/AdviceRequest/${id}`)
  }
  
  setAdviceRequest(data: AdviceRequestModel): Promise<AxiosResponse<ResponseModelNew<AdviceRequestModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<AdviceRequestModel>>(`${CONSTANTS.BASE_API}/api/AdviceRequest`, data)
  }

  setAdviceRequestUpdateStatus(data: AdviceRequestSetStatusModel): Promise<AxiosResponse<ResponseModelNew<AdviceRequestSetStatusModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<AdviceRequestSetStatusModel>>(`${CONSTANTS.BASE_API}/api/AdviceRequest/SetAdviceRequestUpdateStatus`, data)
  }

  // Send mail
  sendMail(data: SendMailModel): Promise<AxiosResponse<ResponseModelNew<SendMailModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<SendMailModel>>(`https://hhq-sendmail.herokuapp.com/send-mail`, data)
  }

  sendMailAnyContent(data: SendEmailAnyContentModel): Promise<AxiosResponse<ResponseModelNew<SendEmailAnyContentModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<SendEmailAnyContentModel>>(`https://hhq-sendmail.herokuapp.com/send-mail-content`, data)
  }

  sendMailHHQ(data: SendMailHHQModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    var bodyFormData = new FormData();
      bodyFormData.append('ToEmail', data.toEmail);
      bodyFormData.append('Subject', data.subject);
      bodyFormData.append('Body', data.body);
      bodyFormData.append('K', data.k);
      bodyFormData.append('Attachments', data.attachments); 
      // IFormFile dạng:
      // const data = new FormData(form);
      // for(var i=0; i <this.state.files.length; i++){
      //     filesArray.push('files'+ i, this.state.files.item(i));
      // }
      // data.append("files", filesArray); 
      const token = localStorage.getItem(CONSTANTS.LOGIN_TOKEN);
      return axios.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Mail/Send`, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })
  }

  // Payment
  getPayments(params: PaymentFilterModel): Promise<AxiosResponse<BaseResponseListModel<PaymentModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<PaymentModel[]>>(`${CONSTANTS.BASE_API}/api/Payment?${queryParams}`);
  }

  getPaymentById(id: string): Promise<AxiosResponse<ResponseModelNew<PaymentModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<PaymentModel>>(`${CONSTANTS.BASE_API}/api/Payment/${id}`);
  }

  deletePayment(id: string): Promise<AxiosResponse<ResponseModelNew<PaymentModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<PaymentModel>>(`${CONSTANTS.BASE_API}/api/Payment/${id}`)
  }
  
  checkPayment(accountId: string, courseId: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Payment/CheckPayment?accountId=${accountId}&courseId=${courseId}`)
  }
  
  setPayment(data: PaymentModel): Promise<AxiosResponse<ResponseModelNew<PaymentModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<PaymentModel>>(`${CONSTANTS.BASE_API}/api/Payment`, data)
  }

  getPaymentTypes(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<PaymentTypeModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<PaymentTypeModel[]>>(`${CONSTANTS.BASE_API}/api/Payment/GetPaymentTypes?${queryParams}`);
  }

  getPaymentTypeById(id: string): Promise<AxiosResponse<ResponseModelNew<PaymentModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<PaymentModel>>(`${CONSTANTS.BASE_API}/api/Payment/GetPaymentTypeById?id=${id}`);
  }

  deletePaymentType(id: string): Promise<AxiosResponse<ResponseModelNew<PaymentTypeModel>>> {
    return axiosSecretInstance.delete<ResponseModelNew<PaymentTypeModel>>(`${CONSTANTS.BASE_API}/api/Payment/DeletePaymentType/${id}`)
  }
  
  setPaymentType(data: PaymentTypeModel): Promise<AxiosResponse<ResponseModelNew<PaymentTypeModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<PaymentTypeModel>>(`${CONSTANTS.BASE_API}/api/Payment/SetPaymentType`, data)
  }

  changePaymentStatus(data: PaymentChangeStatusModel): Promise<AxiosResponse<ResponseModelNew<PaymentChangeStatusModel>>> {
    return axiosSecretInstance.put<ResponseModelNew<PaymentChangeStatusModel>>(`${CONSTANTS.BASE_API}/api/Payment/ChangePaymentStatus`, data)
  }

  // OTP
  verifyOTP(otp: OTPModel): Promise<AxiosResponse<ResponseModelNew<OTPModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<OTPModel>>(`${CONSTANTS.BASE_API}/api/otp/verifyotp`, otp)
  }
  
  createOTP(data: OTPModel): Promise<AxiosResponse<ResponseModelNew<PaymentTypeModel>>> {
    return axiosSecretInstance.post<ResponseModelNew<PaymentTypeModel>>(`${CONSTANTS.BASE_API}/api/Payment/SetPaymentType`, data)
  }

  // GUides
  getGuides(params: GuideFilterModel): Promise<AxiosResponse<BaseResponseListModel<GuideModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosSecretInstance.get<BaseResponseListModel<GuideModel[]>>(`${CONSTANTS.BASE_API}/api/Guide?${queryParams}`)
  }

  deleteGuide(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Guide/${id}`)
  }

  getGuideById(id: string): Promise<AxiosResponse<ResponseModelNew<GuideModel>>> {
    return axiosSecretInstance.get<ResponseModelNew<GuideModel>>(`${CONSTANTS.BASE_API}/api/Guide/${id}`)
  }

  setGuide(data: GuideModel): Promise<AxiosResponse<ResponseModelNew<GuideModel>>> {
    return axiosInstance.post<ResponseModelNew<GuideModel>>(`${CONSTANTS.BASE_API}/api/Guide`, data)
  }

  // Notifications
  getNotifications(params: NotificationFilterModel): Promise<AxiosResponse<BaseResponseListModel<NotificationModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<NotificationModel[]>>(`${CONSTANTS.BASE_API}/api/notification?${queryParams}`)
  }

  getNotificationTypes(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<NotificationTypeModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<NotificationTypeModel[]>>(`${CONSTANTS.BASE_API}/api/Notification/GetNotificationTypes?${queryParams}`)
  }
  
  getAdminNotifications(params: NotificationFilterModel): Promise<AxiosResponse<BaseResponseListModel<NotificationModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<NotificationModel[]>>(`${CONSTANTS.BASE_API}/api/Notification/GetAdminNotifications?${queryParams}`)
  }

  deleteNotification(id: string): Promise<AxiosResponse<ResponseModelNew<NotificationModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/notification/${id}`)
  }

  deleteNotificationAccountMultiple(notificationId: string, accountIds: string): Promise<AxiosResponse<ResponseModelNew<NotificationModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/Notification/DeleteNotificationAccountMultiple`, {
      data: {
        notificationId, accountIds
      }
    })
  }

  getNotificationById(id: string): Promise<AxiosResponse<ResponseModelNew<NotificationModel>>> {
    return axiosInstance.get<ResponseModelNew<NotificationModel>>(`${CONSTANTS.BASE_API}/api/notification/${id}`)
  }

  setNotification(data: NotificationModel): Promise<AxiosResponse<ResponseModelNew<NotificationModel>>> {
    return axiosInstance.post<ResponseModelNew<NotificationModel>>(`${CONSTANTS.BASE_API}/api/notification`, data)
  }
  
  setNotificationRead(id: string): Promise<AxiosResponse<ResponseModelNew<NotificationModel>>> {
    return axiosInstance.post<ResponseModelNew<NotificationModel>>(`${CONSTANTS.BASE_API}/api/Notification/SetNotificationRead?id=${id}`)
  }
  // Test Question
  getTestQuestions(params: TestQuestionTypeFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestDetailQuizModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestDetailQuizModel[]>>(`${CONSTANTS.BASE_API}/api/testQuestion?${queryParams}`)
  }

  getTestQuestionLibraries(params: TestQuestionTypeFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestDetailQuizModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestDetailQuizModel[]>>(`${CONSTANTS.BASE_API}/api/testQuestion/GetTestQuestionLibraries?${queryParams}`)
  }

  deleteTestQuestion(id: string, isMultiple: number): Promise<AxiosResponse<ResponseModelNew<TestDetailQuizModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/testQuestion`, {
      data: {
        id,
        isMultiple
      }
    })
  }

  getTestQuestionById(id: string): Promise<AxiosResponse<ResponseModelNew<TestDetailQuizModel>>> {
    return axiosInstance.get<ResponseModelNew<TestDetailQuizModel>>(`${CONSTANTS.BASE_API}/api/testQuestion/${id}`)
  }

  getTestQuestionNewById(id: string): Promise<AxiosResponse<ResponseModelNew<TestDetailQuizModel>>> {
    return axiosInstance.get<ResponseModelNew<TestDetailQuizModel>>(`${CONSTANTS.BASE_API}/api/TestQuestion/GetTestQuestionNewById?id=${id}`)
  }

  updateTestQuestionChangePublicStatus(id: string, publicStatus: number): Promise<AxiosResponse<ResponseModelNew<TestDetailQuizModel>>> {
    return axiosInstance.get<ResponseModelNew<TestDetailQuizModel>>(`${CONSTANTS.BASE_API}/api/testQuestion/UpdateTestQuestionChangePublicStatus?id=${id}&publicStatus=${publicStatus}`)
  }

  setTestQuestion(data: TestDetailQuizModel): Promise<AxiosResponse<ResponseModelNew<TestDetailQuizModel>>> {
    return axiosInstance.post<ResponseModelNew<TestDetailQuizModel>>(`${CONSTANTS.BASE_API}/api/testQuestion`, data)
  }

  setTestQuestionNew(data: TestDetailQuizModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestQuestion/SetTestQuestionNew`, data);
  }

  makeSameQuestions(data: GPTInputQuestion): Promise<AxiosResponse<ResponseModelNew<GPTOutputQuestion>>> {
    return axiosInstance.post<ResponseModelNew<GPTOutputQuestion>>(`${CONSTANTS.BASE_API}/api/TestQuestion/MakeSameQuestion`, data);
  }

  gradeEssay(data: EssayGradingInput): Promise<AxiosResponse<EssayGradingOutput>> {
    return axiosInstance.post<EssayGradingOutput>(`${CONSTANTS.BASE_API}/api/TestQuestion/GradeEssay`, data);
  }

  gradeEssayBatch(data: EssayGradingInput[]): Promise<AxiosResponse<EssayGradingOutput[]>> {
    return axiosInstance.post<EssayGradingOutput[]>(`${CONSTANTS.BASE_API}/api/TestQuestion/GradeEssayBatch`, data);
  }

  getTestQuestionTuLuanByTeacher(params: TestQuestionTuLuanFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestQuestionTuLuanModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestQuestionTuLuanModel[]>>(`${CONSTANTS.BASE_API}/api/testQuestion/GetTestQuestionTuLuanByTeacher?${queryParams}`)
  }

  getTestQuestionTuLuanDetailByTeacher(params: TestQuestionTuLuanDetailFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestQuestionTuLuanDetailModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestQuestionTuLuanDetailModel[]>>(`${CONSTANTS.BASE_API}/api/testQuestion/GetTestQuestionTuLuanDetailByTeacher?${queryParams}`)
  }


  // Test Attack File
  getTestAttackFileForAccount(courseId: string, testId: string, accountId: string): Promise<AxiosResponse<BaseResponseListModel<TestAttackFileModel[]>>> {
    return axiosInstance.get<BaseResponseListModel<TestAttackFileModel[]>>(`${CONSTANTS.BASE_API}/api/TestAttackFileControler?courseId=${courseId}&testId=${testId}&accountId=${accountId}`)
  }

  deleteTestAttackFile(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/TestAttackFileControler/${id}`)
  }

  getTestAttackById(id: string): Promise<AxiosResponse<ResponseModelNew<TestAttackFileModel>>> {
    return axiosInstance.get<ResponseModelNew<TestAttackFileModel>>(`${CONSTANTS.BASE_API}/api/TestAttackFileControler/${id}`)
  }

  setTestAttackFile(data: TestAttackFileModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestAttackFileControler`, data)
  }

  setTestAttackFileAccept(data: TestAttackFileAcceptModel): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<NewBaseValidateModel>>(`${CONSTANTS.BASE_API}/api/TestAttackFileControler/SetTestAttackFileAccept`, data)
  }
  
  // Test Question Group 
  getTestQuestionGroups(params: TestQuestionGroupFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestQuestionGroupModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestQuestionGroupModel[]>>(`${CONSTANTS.BASE_API}/api/TestQuestionGroup?${queryParams}`)
  }

  deleteTestQuestionGroup(id: number): Promise<AxiosResponse<ResponseModelNew<TestQuestionGroupModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/TestQuestionGroup/${id}`)
  }

  getTestQuestionGroup(id: number): Promise<AxiosResponse<ResponseModelNew<TestQuestionGroupModel>>> {
    return axiosInstance.get<ResponseModelNew<TestQuestionGroupModel>>(`${CONSTANTS.BASE_API}/api/TestQuestionGroup/${id}`)
  }

  setTestQuestionGroup(data: TestQuestionGroupModel): Promise<AxiosResponse<ResponseModelNew<TestQuestionGroupModel | number>>> {
    return axiosInstance.post<ResponseModelNew<TestQuestionGroupModel>>(`${CONSTANTS.BASE_API}/api/TestQuestionGroup`, data)
  }

  // Step
  getSteps(params: StepFilterModel): Promise<AxiosResponse<BaseResponseListModel<StepModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<StepModel[]>>(`${CONSTANTS.BASE_API}/api/step?${queryParams}`)
  }

  deleteStep(id: string): Promise<AxiosResponse<ResponseModelNew<StepModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/step/${id}`)
  }

  getStepByDetail(id: string): Promise<AxiosResponse<ResponseModelNew<StepModel>>> {
    return axiosInstance.get<ResponseModelNew<StepModel>>(`${CONSTANTS.BASE_API}/api/step/${id}`)
  }
  
  setStep(data: StepModel): Promise<AxiosResponse<ResponseModelNew<StepModel | number>>> {
    return axiosInstance.post<ResponseModelNew<StepModel>>(`${CONSTANTS.BASE_API}/api/step`, data)
  }

  // Dashboard
  getAdminDashboard(fromDate: string, toDate: string): Promise<AxiosResponse<ResponseModelNew<DashboardModel>>> {
    return axiosInstance.get<ResponseModelNew<DashboardModel>>(`${CONSTANTS.BASE_API}/api/Dashboard?fromDate=${fromDate}&toDate=${toDate}`)
  }

  getDashboardUserOverview(params: DashboardUserFilterModel): Promise<AxiosResponse<BaseResponseListModel<CourseModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<CourseModel[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardUserOverview?${queryParams}`)
  }

  getDashboardTeacherOverview(): Promise<AxiosResponse<BaseResponseListModel<any[]>>> {
    return axiosInstance.get<BaseResponseListModel<any[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardTeacherOverview`)
  }

  getDashboardTeacherStudentAllCourse(studentId: string): Promise<AxiosResponse<BaseResponseListModel<DashboardTeacherStudentAllCourse[]>>> {
    return axiosInstance.get<BaseResponseListModel<DashboardTeacherStudentAllCourse[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardTeacherStudentAllCourse?studentId=${studentId}`)
  }

  getDashboardUserCourse(courseId: string): Promise<AxiosResponse<ResponseModelNew<DashboardUserCourseModel>>> {
    return axiosInstance.get<ResponseModelNew<DashboardUserCourseModel>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardUserCourse?courseId=${courseId}`)
  }

  getDashboardUserCourseWithAccountId(courseId: string, accountId: string): Promise<AxiosResponse<ResponseModelNew<DashboardUserCourseModel>>> {
    return axiosInstance.get<ResponseModelNew<DashboardUserCourseModel>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardUserCourseWithAccountId?courseId=${courseId}&accountId=${accountId}`)
  }

  getDashboardUserScore(courseId: string): Promise<AxiosResponse<BaseResponseListModel<DashboardUserScore[]>>> {
    return axiosInstance.get<BaseResponseListModel<DashboardUserScore[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardUserScore?courseId=${courseId}`)
  }

  getDashboardTeacherCourse(courseId: string): Promise<AxiosResponse<BaseResponseListModel<any[]>>> {
    return axiosInstance.get<BaseResponseListModel<any[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardTeacherCourse?courseId=${courseId}`)
  }

  getDashboardTeacherTest(courseId: string): Promise<AxiosResponse<BaseResponseListModel<any[]>>> {
    return axiosInstance.get<BaseResponseListModel<any[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardTeacherTest?courseId=${courseId}`)
  }
  
  getDashboardAdminScore(filter: DashboardOverviewFilter): Promise<AxiosResponse<BaseResponseListModel<DashboardAdminScore[]>>> {
    const queryParams = queryString.stringify(filter);
    return axiosInstance.get<BaseResponseListModel<DashboardAdminScore[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardAdminScore?${queryParams}`)
  }

  getDashboardAdminCourse(filter: DashboardOverviewFilter): Promise<AxiosResponse<BaseResponseListModel<DashboardAdminCourse[]>>> {
    const queryParams = queryString.stringify(filter);
    return axiosInstance.get<BaseResponseListModel<DashboardAdminCourse[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardAdminCourse?${queryParams}`)
  }

  getDashboardAdminCourseDetail(params: FilterDashboardAdminCourseDetail): Promise<AxiosResponse<BaseResponseListModel<DashboardAdminCourseDetail[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<DashboardAdminCourseDetail[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardAdminCourseDetail?${queryParams}`)
  }

  getDashboardAdminOverview(filter: DashboardOverviewFilter): Promise<AxiosResponse<BaseResponseListModel<DashboardAdminOverview[]>>> {
    const queryParams = queryString.stringify(filter);
    return axiosInstance.get<BaseResponseListModel<DashboardAdminOverview[]>>(`${CONSTANTS.BASE_API}/api/Dashboard/GetDashboardAdminOverview?${queryParams}`)
  }

  // Test View
  getTestView(params: TestViewFilterModel): Promise<AxiosResponse<BaseResponseListModel<TestViewModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<TestViewModel[]>>(`${CONSTANTS.BASE_API}/api/TestView?${queryParams}`)
  }

  deleteTestView(id: string): Promise<AxiosResponse<ResponseModelNew<TestViewModel>>> {
    return axiosInstance.delete(`${CONSTANTS.BASE_API}/api/TestView/${id}`)
  }

  getTestViewById(courseId: string, testId: string): Promise<AxiosResponse<ResponseModelNew<TestViewModel>>> {
    return axiosInstance.get<ResponseModelNew<TestViewModel>>(`${CONSTANTS.BASE_API}/api/TestView/GetTestViewById?courseId=${courseId}&testId=${testId}`)
  }
  
  setTestView(data: TestViewModel): Promise<AxiosResponse<ResponseModelNew<number>>> {
    return axiosInstance.post<ResponseModelNew<number>>(`${CONSTANTS.BASE_API}/api/TestView`, data)
  }

  // GroupManager
  getGroupManagers(params: GroupManagerFilterModel): Promise<AxiosResponse<ResponseModelNew<GroupManagerModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<ResponseModelNew<GroupManagerModel[]>>(`${CONSTANTS.BASE_API}/api/GroupManager?${queryParams}`)
  }

  getGroupManagerMembers(params: GroupManagerFilterModel): Promise<AxiosResponse<BaseResponseListModel<AccountUserModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<AccountUserModel[]>>(`${CONSTANTS.BASE_API}/api/GroupManager/GetGroupManagerMembers?${queryParams}`)
  }

  // RoleTypeData
  getRoleTypeDatas(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<RoleTypeDataModel[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<RoleTypeDataModel[]>>(`${CONSTANTS.BASE_API}/api/RoleDataType?${queryParams}`)
  }


  // Realtime
  setConversationSingleUser(id: string): Promise<AxiosResponse<ResponseModelNew<string>>> {
    return axiosInstance.get<ResponseModelNew<string>>(`${CONSTANTS.BASE_API}/api/Conversation/SetConversationSingleUser?receiveAccountId=${id}`)
  }

  setConversationmultipleUser(receiveAccountIds: string): Promise<AxiosResponse<ResponseModelNew<string>>> {
    return axiosInstance.post<ResponseModelNew<string>>(`${CONSTANTS.BASE_API}/api/Conversation/SetConversationMultipleUser`, {receiveAccountIds})
  }

  getConversationUsers(params: BaseFilterModel): Promise<AxiosResponse<BaseResponseListModel<ConversationUser[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<ConversationUser[]>>(`${CONSTANTS.BASE_API}/api/Conversation/GetConversationUsers?${queryParams}`)
  }

  getConversationById(id: string): Promise<AxiosResponse<ResponseModelNew<ConversationUser>>> {
    return axiosInstance.get<ResponseModelNew<ConversationUser>>(`${CONSTANTS.BASE_API}/api/Conversation/${id}`)
  }

  getConversationUserNoReadCount(): Promise<AxiosResponse<ResponseModelNew<number>>> {
    return axiosInstance.get<ResponseModelNew<number>>(`${CONSTANTS.BASE_API}/api/Conversation/ConversationUserNoReadCount`)
  }
  
  getConversationMessages(params: MessageByConversationFilterModel): Promise<AxiosResponse<BaseResponseListModel<Message[]>>> {
    const queryParams = queryString.stringify(params);
    return axiosInstance.get<BaseResponseListModel<Message[]>>(`${CONSTANTS.BASE_API}/api/message/GetConversationMessages?${queryParams}`)
  }

  setConversation(data: ConversationUser): Promise<AxiosResponse<ResponseModelNew<BaseValidateModel>>> {
    return axiosInstance.post<ResponseModelNew<BaseValidateModel>>(`${CONSTANTS.BASE_API}/api/Conversation`, data)
  }
}
export default new ApiService();